//门户样式
import './css/';
//门户相关
import Homepage from './components/Homepage';
//门户设置
import PortalSetting from './components/PortalSetting';
//元素组件
import ElementIndie from './components/ElementIndie';
//协同区组件
import Synergy from './components/Synergy';
//协同区门户设置组件
import SynergyPortalSetting from './components/SynergyPortalSetting';

const PortalCom = function(props){
	return <Homepage {...props}/>
};

import {Route} from 'react-router';
import {WeaLocaleProvider} from 'ecCom';
const getLocaleLabel = WeaLocaleProvider.getLocaleLabel.bind(this, 'portal');

const PortalRoute = (
    <Route path="portal" onEnter={getLocaleLabel}>
        <Route path="portal-:hpid-:subCompanyId" component={Homepage}/>
    </Route>
);

module.exports = {
    Route: PortalRoute,
    store: {},
    Homepage,
    PortalSetting,
    ElementIndie,
    Synergy,
    SynergyPortalSetting,
    PortalCom
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/index.js